import { request, Row, Rows } from './request';
import { FetchPartnerScheduleTimesQuery } from './models/partner-schedules/req/FetchPartnerScheduleTimesQuery';
import AppError from './models/common/res/AppError';
import { PartnerScheduleTime } from './models/partner-schedules/res/PartnerScheduleTime';
import { FetchPartnerScheduleAvailableDateQuery } from './models/partner-schedules/req/FetchPartnerScheduleAvailableDateQuery';
import { PartnerScheduleAvailableDate } from './models/partner-schedules/res/PartnerScheduleAvailableDate';
import { EmployeeScheduleInfo } from './models/partner-schedules/res/EmployeeScheduleInfo';

export const fetchAvailableReservationTimes = async (
  query: FetchPartnerScheduleTimesQuery,
): Promise<PartnerScheduleTime[]> => {
  const url = `/app/partner-schedules/available-times`;
  try {
    const { data } = await request<Row<any>>({
      method: 'get',
      url,
      queryParams: query,
    });
    const { row } = data;
    const { pivotSchedule } = row;
    return pivotSchedule.map((schedule: Record<string, boolean>) => {
      let timeText = '';
      let available = false;
      const keys = Object.keys(schedule);
      if (keys.length > 0) {
        const [key] = keys;
        timeText = key;
        available = schedule[key];
      }
      const partnerScheduleTime: PartnerScheduleTime = {
        timeText,
        available,
      };
      return partnerScheduleTime;
    });
  } catch (e) {
    throw new AppError(e);
  }
};

export const fetchAvailableReservationDates = async (
  query: FetchPartnerScheduleAvailableDateQuery,
): Promise<Record<string, PartnerScheduleAvailableDate>> => {
  const url = `/app/partner-schedules/available-dates`;
  try {
    const { data } = await request<
      Row<Record<string, PartnerScheduleAvailableDate>>
    >({
      method: 'get',
      url,
      queryParams: query,
    });
    const { row } = data;
    return row;
  } catch (e) {
    throw new AppError(e);
  }
};

export const fetchEmployeeSchedules = async (
  partnerCode: string,
  query: {
    date: string;
    productOptionIds?: number[];
    languageCode?: string;
  },
) => {
  const url = `v2/customer/partner-schedule/employee-schedule`;

  const headers = {
    'boostree-origin': `https://${partnerCode}.boostree.partners`,
  };
  try {
    const { data } = await request<Rows<EmployeeScheduleInfo>>({
      method: 'get',
      url,
      queryParams: query,
      headers,
    });
    return {
      rows: data.rows.filter(({ partnerEmployees }) => {
        return (
          partnerEmployees.filter(({ isWork }) => {
            return !isWork;
          }).length === partnerEmployees.length && partnerEmployees.length > 0
        );
      }),
      count: data.count,
    };
  } catch (e) {
    throw new AppError(e);
  }
};
